import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { TransactionIdScopeType } from "../../enums/transactionIdScopeType";
import { RootState } from "../stores/store";

type SliceState = {
  pageScopeTransactionId: string;
  systemScopeTransactionId: string;
  currentScopeType: TransactionIdScopeType;
};

const initialState: SliceState = {
  pageScopeTransactionId: "",
  systemScopeTransactionId: "",
  currentScopeType: TransactionIdScopeType.SystemScope,
};

const transactionIdSlice = createSlice({
  name: "transactionIdSlice",
  initialState,
  reducers: {
    setPageScopeTransactionId(state, { payload }: PayloadAction<string>) {
      state.pageScopeTransactionId = payload;
    },
    setSystemScopeTransactionId(state, { payload }: PayloadAction<string>) {
      state.systemScopeTransactionId = payload;
    },
    setCurrentScopeType(state, { payload }: PayloadAction<TransactionIdScopeType>) {
      state.currentScopeType = payload;
    },
    setInitialTransactionId(state) {
      state.currentScopeType = initialState.currentScopeType;
      state.pageScopeTransactionId = initialState.pageScopeTransactionId;
      state.systemScopeTransactionId = initialState.systemScopeTransactionId;
    },
  },
});

export const { setPageScopeTransactionId, setSystemScopeTransactionId, setCurrentScopeType, setInitialTransactionId } =
  transactionIdSlice.actions;

export const selectPageScopeTransactionId = (state: RootState) => state.transactionIdSlice.pageScopeTransactionId;

export const selectSystemScopeTransactionId = (state: RootState) => state.transactionIdSlice.systemScopeTransactionId;

export const selectCurrentScopeType = (state: RootState) => state.transactionIdSlice.currentScopeType;

export const transactionIdSliceReducer = transactionIdSlice.reducer;
